import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikGetOrientation extends ASTBlock {
    constructor(color) {
        super(color, "alvik_get_orientation")
        this.predefinedInputs = {}
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "type": "BooleanBlock",
            "tooltip": "",
            "helpUrl": "",
            "message0": "gib die Drehung um die %1 Achse in Grad %2",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "axis",
                    "options": [
                        [
                            "x",
                            "r"
                        ],
                        [
                            "y",
                            "p"
                        ],
                        [
                            "z",
                            "y"
                        ]
                    ]
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "output": "Number"
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}